<template>
  <button
    type="button"
    class="btn"
    :aria-label="ariaLabel"
    :class="classObject"
    :disabled="disabled"
    @click="$listeners.click || onClick"
  >
    {{ getTitle }}
  </button>
</template>
<script>
import modelMixin from '../mixins/modelMixin';

const bootstrapColors = ['secondary', 'primary', 'success', 'info', 'danger', 'warning', 'link'];

export default {
  name: 'WButton',

  mixins: [modelMixin],
  props: {
    small: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    color: { type: String, default: 'secondary' },
    ariaLabel: { type: String }
  },
  data() {
    return {};
  },
  computed: {
    classObject() {
      const result = [];
      if (bootstrapColors.includes(this.color)) {
        result.push('btn-' + this.color);
      } else {
        result.push(this.color);
      }
      if (this.disabled) {
        result.push('disabled');
      }
      return result;
    }
  },
  methods: {
    onClick() {
      this.$emit('click');
    }
  }
};
</script>
